<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addClassTime" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加课堂时间</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="startTime" label="开始时间" show-overflow-tooltip />
          <el-table-column prop="endTime" label="结束时间" show-overflow-tooltip />
          <el-table-column prop="num" label="排序" show-overflow-tooltip />
          <el-table-column prop="remark" label="备注" show-overflow-tooltip />
          <el-table-column prop="state" label="状态" width="75px" align="center">
            <template #default="{ row }">
              <el-switch v-model="row.status" @change="editState(row)" active-value="1" inactive-value="0" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <!--              <el-link @click="editClassTime(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>-->
              <el-popconfirm title="确定要删除此课堂时间吗？" @onConfirm="deleteClassTime(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改课堂时间' : '添加课堂时间'"
      :visible.sync="showEdit"
      width="430px"
      @closed="resetForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="开始时间:" prop="startTime">
          <el-time-picker v-model="editForm.startTime" placeholder="选择开始时间" value-format="HH:mm" />
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime">
          <el-time-picker v-model="editForm.endTime" placeholder="选择结束时间" value-format="HH:mm" />
        </el-form-item>
        <el-form-item label="排序:" prop="num">
          <el-input-number v-model="editForm.num" :min="1" :step="1" label="排序"></el-input-number>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.remark"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveClassTime(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { saveClassTime, saveSignConfigState, updStatusClassTime } from '@/config/api';

  export default {
    name: '',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/classTime/list',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        data: null,
        choose: [],
        editForm: {
          startTime: null,
          endTime: null,
          num: null,
          remark: null,
        },
        editRules: {
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
          num: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        },
        showEdit: false,
      };
    },
    methods: {
      // 打开添加课堂时间弹窗
      addClassTime() {
        this.showEdit = true;
      },
      // 编辑课堂时间
      // editClassTime(row) {
      //   this.editForm = Object.assign({}, row);
      //   this.showEdit = true;
      // },
      // 保存课堂时间
      saveClassTime() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveClassTime(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 更改状态
      editState(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        formData.append('status', row.status);
        updStatusClassTime(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已改变状态' });
            this.$refs.table.reload();
          } else {
            row.state = !row.state ? 1 : 0;
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 删除课堂时间
      deleteClassTime(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        formData.append('status', -1);
        updStatusClassTime(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 重置表单
      resetForm() {
        this.editForm = {
          startTime: null,
          endTime: null,
          num: null,
          remark: null,
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped lang="scss"></style>
